
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { NotificationPreferences as NotificationPrefs } from "@/types/profile";

interface NotificationPreferencesProps {
  preferences: NotificationPrefs;
  onChange: (preferences: NotificationPrefs) => void;
}

export const NotificationPreferences = ({ preferences, onChange }: NotificationPreferencesProps) => {
  const handleToggle = (key: keyof NotificationPrefs) => {
    onChange({
      ...preferences,
      [key]: !preferences[key]
    });
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Notification Preferences</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Email Notifications</Label>
            <p className="text-sm text-muted-foreground">
              Receive updates and alerts via email
            </p>
          </div>
          <Switch
            checked={preferences.email}
            onCheckedChange={() => handleToggle('email')}
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>Push Notifications</Label>
            <p className="text-sm text-muted-foreground">
              Receive notifications in your browser
            </p>
          </div>
          <Switch
            checked={preferences.push}
            onCheckedChange={() => handleToggle('push')}
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label>SMS Notifications</Label>
            <p className="text-sm text-muted-foreground">
              Receive important updates via text message
            </p>
          </div>
          <Switch
            checked={preferences.sms}
            onCheckedChange={() => handleToggle('sms')}
          />
        </div>
      </CardContent>
    </Card>
  );
};
